import React from 'react';
import { Route, BrowserRouter, Switch } from 'react-router-dom';
import Home from './components/screens/Home/Home';
import About from './components/screens/About/About';
import FindCE from './components/screens/FindCE/FindCE';
import Corporate from './components/screens/Corporate/Corporate';
import Profession from './components/screens/Profession/Profession';
import Thanks from './components/screens/Thanks/Thanks';
import Login from './components/screens/Login/Login';
import Signup from './components/screens/Signup/Signup';
import Course from './components/screens/Course/Course';
import NoMatch from './components/screens/NoMatch/NoMatch';
import ResetPassword from './components/screens/ResetPassword/ResetPassword';
import ForgotPassword from './components/screens/ForgotPassword/ForgotPassword';
import ChangePassword from './components/screens/ChangePassword/ChangePassword';
import Nursing from './components/screens/Industry/Nursing';
import Signout from './components/screens/Signout/Signout';
import Resources from './components/screens/Resources/Resources';
import Post from './components/screens/Post/Post';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import Dentistry from './components/screens/Industry/Dentistry';

const Router = ({ data: { error, professionPages, courses, bundles } }) => {
  if (error) return <h1>Error fetching routes!</h1>;
  if (professionPages) {
    return (
      <BrowserRouter>
        <div>
          <Switch>
            <Route
              exact
              path="/"
              render={() => {
                return <Home onEnter={window.scrollTo(0, 0)} />;
              }}
            />
            <Route
              path="/sign_out"
              render={() => {
                return <Signout />;
              }}
            />
            <Route
              path="/about"
              render={() => {
                return <About onEnter={window.scrollTo(0, 0)} />;
              }}
            />
            <Route
              path="/findce"
              render={() => {
                return <FindCE onEnter={window.scrollTo(0, 0)} />;
              }}
            />
            <Route
              path="/corporate"
              render={() => {
                return <Corporate onEnter={window.scrollTo(0, 0)} />;
              }}
            />
            <Route
              path="/login"
              render={() => {
                return <Login onEnter={window.scrollTo(0, 0)} />;
              }}
            />
            />
            <Route
              path="/signup"
              render={() => {
                return <Signup onEnter={window.scrollTo(0, 0)} />;
              }}
            />
            <Route
              path="/changepassword"
              render={() => {
                return <ChangePassword onEnter={window.scrollTo(0, 0)} />;
              }}
            />
            <Route path="/resources/:slug" component={Post} />
            <Route exact path="/resources" component={Resources} />
            <Route exact path="/reset/password" component={ResetPassword} />
            <Route exact path="/forgot/password" component={ForgotPassword} />
            <Route
              path="/nursing"
              render={() => {
                return <Nursing onEnter={window.scrollTo(0, 0)} />;
              }}
            />
            <Route
              path="/Dentistry/California"
              render={() => {
                return <Dentistry onEnter={window.scrollTo(0, 0)} />;
              }}
            />
            {professionPages &&
              professionPages.map((key, index) => {
                let state = key.state.trim().replace(/\s+/g, '-');
                let profession = key.profession.trim().replace(/\s+/g, '-');
                return (
                  <Route
                    key={index}
                    path={`/${profession}/${state.trim()}`}
                    render={() => (
                      <Profession
                        ceRequirements={key.ceRequirements}
                        onEnter={window.scrollTo(0, 0)}
                        state={key.state}
                        profession={key.profession}
                        learnMore={key.learnMore}
                        mandatoryHours={key.mandatoryHours}
                        totalHours={key.totalHours}
                        accreditations={key.accreditations}
                        requiredTime={key.requiredTime}
                        generalTime={key.generalTime}
                        generalHours={key.generalHours}
                        allOnline={key.allOnline}
                        slug={key.slug}

                        // img={`https://media.graphcms.com/${
                        //   key.mainArtwork.handle
                        // }`}
                      />
                    )}
                  />
                );
              })}
            {courses &&
              courses.map((key, index) => {
                return (
                  <Route
                    key={index}
                    path={`/${key.id}`}
                    render={() => (
                      <Course
                        type="course"
                        onEnter={window.scrollTo(0, 0)}
                        instructor={key.instructor}
                        aboutThisCourse={key.aboutThisCourse}
                        requirementsDescription={key.requirementsDescription}
                        learnMore={key.learnMore}
                        slug={key.slug}
                        twentyNumber={key.twentyNumber}
                        accreditations={key.accreditations}
                        textOverlayTitleMainArtwork={
                          key.textOverlayTitleMainArtwork
                        }
                        textOverlayDescMainArtwork={
                          key.textOverlayDescMainArtwork
                        }
                        price={key.price}
                        checkoutLink={key.checkoutLink}
                        // img={`https://media.graphcms.com/${
                        //   key.mainArtwork.handle
                        // }`}
                        gTagManagerId={key.gTagManagerId}
                      />
                    )}
                  />
                );
              })}
            {bundles &&
              bundles.map((key, index) => {
                return (
                  <Route
                    key={index}
                    path={`/${key.id}`}
                    render={() => (
                      <Course
                        type="bundle"
                        onEnter={window.scrollTo(0, 0)}
                        aboutThisCourse={key.aboutThisCourse}
                        requirementsDescription={key.requirementsDescription}
                        learnMore={key.learnMore}
                        instructor={key.instructor}
                        slug={key.slug}
                        bundleCard={key.bundleCard}
                        twentyNumber={key.twentyNumber}
                        accreditations={key.accreditations}
                        textOverlayTitleMainArtwork={
                          key.textOverlayTitleMainArtwork
                        }
                        textOverlayDescMainArtwork={
                          key.textOverlayDescMainArtwork
                        }
                        price={key.price}
                        checkoutLink={key.checkoutLink}
                        gTagManagerId={key.gTagManagerId}
                        // img={`https://media.graphcms.com/${
                        //   key.mainArtwork.handle
                        // }`}
                      />
                    )}
                  />
                );
              })}
            <Route
              exact
              path="/thanks"
              onEnter={window.scrollTo(0, 0)}
              component={Thanks}
            />
            <Route onEnter={window.scrollTo(0, 0)} component={NoMatch} />
          </Switch>
        </div>
      </BrowserRouter>
    );
  } else {
    return null;
  }
};

export const pages = gql`
  query {
    professionPages(where: { status: PUBLISHED }) {
      id
      state
      profession
      slug
      learnMore
      generalHours
      mandatoryHours
      totalHours
      allOnline
      accreditations
      ceRequirements
      requiredTime
      generalTime
    }
    courses(where: { status: PUBLISHED }) {
      id
      requirementsDescription
      slug
      twentyNumber
      learnMore
      textOverlayTitleMainArtwork
      textOverlayDescMainArtwork
      price
      checkoutLink
      aboutThisCourse
      accreditations
      gTagManagerId
      instructor {
        id
        name
        title
        bio
        avatar {
          handle
        }
      }
    }
    bundles(where: { status: PUBLISHED }) {
      id
      requirementsDescription
      slug
      twentyNumber
      aboutThisCourse
      learnMore
      textOverlayTitleMainArtwork
      textOverlayDescMainArtwork
      instructor {
        id
        name
        title
        bio
        avatar {
          handle
        }
      }
      bundleCard {
        handle
      }
      price
      accreditations
      checkoutLink
      gTagManagerId
    }
  }
`;

export default graphql(pages, {
  props: ({ data }) => ({
    data,
  }),
})(Router);



// WEBPACK FOOTER //
// ./src/Router.js